module.exports = __webpack_public_path__ + "img/logo_art.a85b5c51.svg";